var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "md-button",
        {
          staticClass:
            "md-primary md-just-icon md-round pull-right header-button",
          attrs: { title: _vm.title },
          on: { click: _vm.batchUpload },
        },
        [_c("md-icon", [_vm._v("publish")])],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }